import { useEffect, useState } from "react";
import { FormModalDialog } from "../../../../components/ui";
import { getDateInLocalTZFromDateStr } from "../../../../utils/datetime";

/**
 * Renders a modal dialog for setting a custom time for a specific job scope.
 *
 * @Note Coded by Ben and not refactored. Remains a bit messy and inconsistent, but
 * isn't too bad and it works well enough so left as is for time reasons.
 * 
 * @Note2 Ideally this would be a re-usable component combining at least time and 
 * address. If we have need for another component like this in future, take the time to
 * combine these and refactor in the process.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.scope - The scope object containing job details and custom time.
 * @param {boolean} props.open - A boolean indicating whether the modal is open or not.
 * @param {function} props.onClose - Callback function to handle closing the modal.
 * @param {function} props.onSubmit - Callback function to handle form submission.
 * @returns {JSX.Element} The rendered component.
 */
export default function EditScopeCustomTimeModal({
  scope,
  open,
  onClose,
  onSubmit,
}) {
  const [formState, setformState] = useState(null);

  useEffect(() => {
    if (!open && formState !== null) {
      setformState(null);
    }

    if (open && formState === null) {
      const newState = {
        custom_time: scope["custom_time"] || null,
      };

      setformState(newState);
    }
  }, [formState, open, scope]);

  const formattedDate = getDateInLocalTZFromDateStr(scope.date).toDateString();

  return (
    <FormModalDialog
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      title={"Set custom time"}
      descriptionSlot={
        <div>
          <span>Set a custom time for </span>
          <span>
            {scope.job.number} - {scope.job.description}
          </span>
          <span> on </span>
          <span>{formattedDate}</span>
        </div>
      }
      formSlot={
        formState && (
          <div className={"flex flex-col space-y-2"}>
            <div>
              <input
                type={"time"}
                placeholder={"Enter a custom time"}
                name="custom_time"
                defaultValue={
                  formState["custom_time"] ? formState["custom_time"] : "07:00"
                }
                className={
                  "rounded bg-white outline outline-1 outline-gray-300 focus:outline-2 focus:outline-sky-400 p-2 w-full"
                }
              />
            </div>
          </div>
        )
      }
    />
  );
}
